import React, {useState, useEffect} from "react";
import {useForm, Controller} from "react-hook-form";
import {Container, Row, Col} from "react-bootstrap";
import Noti from "../../../util/noti";
import {useUser} from "../../../util/user";
import GYAxios from "../../../util/GYAxios";
import moment from "moment-timezone";
import {useUserProps} from "../../../util/userDBContext";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import styles from "./SiteCreation.module.css";
import Loader from "./../../general/Loader";
import { useHistory } from "../../../util/router";

export const AccountingForm = (props) => {
	const [showInfo, setShowInfo] = useState(false);

	const {loggedCountry} = useUserProps();
	const user = useUser();

	const history = useHistory();

	const [listRetrieved, setListRetrieved] = useState(false);

	const [siteData, setSiteData] = useState({});
	const {register, handleSubmit, errors, setValue, watch, control, reset, unregister} = useForm();
	const [isReadOnly, setIsReadOnly] = useState(true);

	const siteView = user.roles.includes("administration:SiteCreation:_view");
	const siteAcct = user.roles.includes("administration:SiteCreation:_editAcct") && !user.roles.includes("_TH:GY:ACCT");
	const siteAdmin = user.roles.includes("administration:SiteCreation:_admin");
	const acctApproval = user.roles.includes("administration:SiteCreation:_approvalAcct") && siteData?.isRejected === 2 && siteData?.isSent === 1;

	const [banksList, setBanksList] = useState([]);
	const [entitiesList, setEntitiesList] = useState([]);
	const [easList, setEasList] = useState([]);
	const [tariffsList, setTariffsList] = useState([]);
	const [postalsList, setPostalsList] = useState([]);

	const currencies = [
		{label: "VND", value: "VND", group: "default", disabled: loggedCountry !== "VN" && siteAcct},
		{label: "THB", value: "THB", group: "default", disabled: loggedCountry !== "TH" && siteAcct},
		{label: "KHR", value: "KHR", group: "default", disabled: loggedCountry !== "KH" && siteAcct},
	];

	const ToP_choices = [
		{label: "Yes", value: 1, group: "default"},
		{label: "No", value: 0, group: "default"},
	];

	const [needLoader, setNeedLoader] = useState(false); // need loader or not
	const [showLoader, setShowLoader] = useState({position: "relative"});

	const loaderMounted = (boo) => {
		if (boo) {
			setShowLoader({position: "fixed"});
			setNeedLoader(true);
		} else {
			setShowLoader({position: "relative"});
			setNeedLoader(false);
		}
	};

	const compareObj = (a, b) => {
		// we use != instead of !== because we want to compare string number with number
		const obj_ = Object.entries(b)
			.filter(([key, val]) => a[key] != val && key in a)
			.reduce((a, [key, v]) => ({...a, [key]: v}), {});
		return obj_;
	};

	const trimStr = (str) => {
		if (!str) return str;
		return str.replace(/^\s+/g, '');
	};

	const customer_id = watch("customer_id", siteData?.customer_id || "");
	const site_code = watch("site_code", siteData?.site_code || "");
	const location = watch("location", siteData?.location || "");
	const EA_id = watch("EA_id", siteData?.EA_id || "");
	const tariff_id = watch("tariff_id", siteData?.tariff_id || "");
	const solar_entity = watch("solar_entity", siteData?.solar_entity || "");
	const discount_on = watch("discount_on", siteData?.discount_on || "");
	const discount_off = watch("discount_off", siteData?.discount_off || "");
	const FT_discount = watch("FT_discount", siteData?.FT_discount || "");
	const credit_term = watch("credit_term", siteData?.credit_term || "");
	const tax_id = watch("tax_id", siteData?.tax_id || "");
	const comment = watch("comment", siteData?.comment || "");
	const bank_id = watch("bank_id", siteData?.bank_id || "");
	const billing_address = watch("billing_address", siteData?.billing_address || "");
	const billing_name = watch("billing_name", siteData?.billing_name || "");
	const mail_name = watch("mail_name", siteData?.mail_name || "");
	const mail_bill_add = watch("mail_bill_add", siteData?.mail_bill_add || "");
	const mail_phone_no = watch("mail_phone_no", siteData?.mail_phone_no || "");
	const ToP = watch("ToP", siteData?.ToP || "");
	const currency = watch("currency", siteData?.currency || "");
	const postal_id = watch("postal_id", siteData?.postal_id || "");

	const getList = async () => {
		const uriBank = siteAdmin ? `/select/banks` : `/select/banks/${loggedCountry}`;
		const uriEntity = siteAdmin ? `/select/entities` : `/select/entities/${loggedCountry}`;
		const uriEA = siteAdmin ? `/select/eas` : `/select/eas/${loggedCountry}`;
		const uriTariff = siteAdmin ? `/select/tariffs` : `/select/tariffs/${loggedCountry}`;

		try {
			const [bank, entity, eAuth, tariff] = await Promise.all([
				GYAxios.get(uriBank),
				GYAxios.get(uriEntity),
				GYAxios.get(uriEA),
				GYAxios.get(uriTariff),
			]).catch((error) => {
				console.log(error);
				const msg = "Error fetching lists. Please contact your IT support.";
				Noti.create({type: "e", msg});
				return;
			});

			if (bank.data) {
				const temps = bank.data.map((v) => {
					return {label: v.label, value: v.value};
				});
				setBanksList(temps);
			}
			if (entity.data) {
				const temps = entity.data.map((v) => {
					return {label: v.label, value: v.value};
				});
				setEntitiesList(temps);
			}
			if (eAuth.data) {
				const temps = eAuth.data.map((v) => {
					return {label: v.label, value: v.value};
				});
				setEasList(temps);
			}
			if (tariff.data) {
				const temps = tariff.data.map((v) => {
					return {label: v.label, value: v.value};
				});
				setTariffsList(temps);
			}
			setListRetrieved(true);
		} catch (error) {
			console.log(error);
			const msg = "Error fetching lists. Please contact your IT support.";
			Noti.create({type: "e", msg});
			return;
		}
	};

	function renderSelect (type, onChange, list, value, defVal = null) {
		const selectStyle = {
			container: () => ({float: "none", }),
			control: (provided) => ({...provided, height: "40px", }),
		};

		switch (type) {
			case "cr":
				return (
					<CreatableSelect
						isSearchable={true}
						isDisabled={isReadOnly}
						isClearable={!isReadOnly}
						options={list}
						value={list.find((c) => c.value == value)}
						onChange={(val) => onChange(val?.label || null)} // for customer ID only
						isLoading={list.length === 0}
						styles={selectStyle}
						defaultValue={defVal}
					/>
				);
			case "se":
				return (
					<Select
						isSearchable={true}
						isDisabled={isReadOnly}
						options={list}
						value={list.find((c) => c.value == value)} // purposely use == 
						onChange={(val) => onChange(val.value)}
						isLoading={list.length === 0}
						styles={selectStyle}
						isOptionDisabled={(option) => option.disabled}
						defaultValue={defVal}
					/>
				);
			default:
				return null;
		}
	}

	function renderInput (valName, len, require = false, type = "text") {
		let val = eval(valName);
		const maxNum = type === "number" ? getMaxNum(len) : "";

		return (
			<input
				type={type}
				className={styles.inputField}
				value={val !== null ? val : ""}
				{...register(valName, {required: require})}
				onChange={(e) => setValue(valName, trimStr(e.target.value))}
				maxLength={len}
				max={maxNum}
			/>
		);
	}

	const getMaxNum = (len) => Math.pow(10, len) - 1;

	async function updateAcctInfo (amend_info) {
		if (siteData.isSent === 1 && siteData.isRejected !== 1) {
			const ques = "This site has been sent to Department Manager for approval. Are you sure you want to amend it?";
			if (!window.confirm(ques)) return;
		}

		const uri = `/site_creation/acct_info/update/${siteData.acct_id}`;
		const param_01 = {
			...amend_info,
			isSent: 0,
			isRejected: 2,
			lastUpdatedBy: user.email,
			lastUpdatedAt: moment().format("YYYY-MM-DD"),
		};

		try {
			await GYAxios.patch(uri, param_01).then(() => {
				Noti.create({type: "s", msg: "Saved!"});
			});
		} catch (error) {
			console.log(error);
			const msg = "Error in updating info. Please contact your IT support.";
			Noti.create({type: "e", msg});
			return;
		}

		if (siteData.isSent === 1 && siteData.isExecuted === 0) {
			loaderMounted(true);
			try {
				const param = {
					...param_01,
					country: siteData.country,
					site_name: siteData.site_name,
					temp_client_name: siteData.temp_client_name,
					role: "administration:SiteCreation:_approvalAcct",
					email: user.email
				};
				const uri = "/site_creation/sendEmailToDepManagerForNoticeAmendment";
				await GYAxios.post(uri, param).then((res) => {
					Noti.create({type: 's', msg: res.data.message});
					const timer = setTimeout(() => {
						history.push('/solar/administration/site-creation/manage-site/invoicing-info-table');
					}, 500);

					return () => clearTimeout(timer);
				});
			} catch (err) {
				const msg = "Error in sending email. Please contact your IT support.";
				Noti.create({type: 'e', msg: msg});
				loaderMounted(false);
			}
		} else {
			const timer = setTimeout(() => {
				history.push('/solar/administration/site-creation/manage-site/invoicing-info-table');
			}, 500);

			return () => clearTimeout(timer);
		}
	}

	async function rejectSite () {
		const newRemark = prompt("Tell us the reason:", "");
		if (newRemark == null || newRemark?.trim() == "") return;

		loaderMounted(true);

		const param = {
			...siteData,
			isRejected: 1,
			decidedEmail: user.email,
			remark: newRemark,
		};

		try {
			await GYAxios.post("/site_creation/rejectSite", param).then((res) => {
				Noti.create({type: 's', msg: `Rejected.\n${res.data.message}`});
				const timer = setTimeout(() => {
					loaderMounted(false);
					history.push('/solar/administration/site-creation/manage-site/invoicing-info-table');
				}, 500);

				return () => clearTimeout(timer);

			});
		} catch (err) {
			const msg = "Error in rejecting site. Please contact your IT support.";
			Noti.create({type: "e", msg});
			loaderMounted(false);
		}
	}

	async function approveSite () {
		const question = `Are you sure you want to approve this site?`;
		const confirm = window.confirm(question);
		if (!confirm) return;

		loaderMounted(true);

		const param = {
			...siteData,
			isRejected: 0,
			decidedEmail: user.email
		};

		try {
			await GYAxios.post("/site_creation/approveAcctSite", param).then((res) => {
				Noti.create({type: 's', msg: `Approved.\n${res.data.message}`});
			});
		} catch (err) {
			const msg = "Error in rejecting site. Please contact your IT support.";
			Noti.create({type: "e", msg});
			loaderMounted(false);
			return;
		}

		try {
			await GYAxios.post("/site_creation/send/acct", param);
			const timer = setTimeout(() => {
				loaderMounted(false);
				history.push('/solar/administration/site-creation/manage-site/invoicing-info-table');
			}, 500);

			return () => clearTimeout(timer);
		} catch (err) {
			const msg = "Error in rejecting site. Please contact your IT support.";
			Noti.create({type: "e", msg});
			loaderMounted(false);
		}
	}

	function onSubmit (data) {
		if (Object.keys(data).length === 0) {
			const msg = "There is nothing to save.";
			Noti.create({type: "w", msg});
			return;
		}

		if (data.postal_id != 0) {
			data.mail_bill_add = null;
			data.mail_name = null;
			data.mail_phone_no = null;
		}

		const filteredChanges = compareObj(siteData, data);
		if (Object.keys(filteredChanges).length === 0) {
			const msg = "There is nothing to save.";
			Noti.create({type: "w", msg});
			return;
		}

		if (filteredChanges.site_code) {
			const space = filteredChanges.site_code.includes(" ");
			if (space) {
				const msg = "Site Code cannot have space.";
				Noti.create({type: "e", msg});
				return;
			}
		}

		const values = Object.values(filteredChanges);
		for (let i = 0; i < values.length; i++) {
			const parsed = parseFloat(values[i]);
			if (!isNaN(parsed)) {
				if (parsed < 0) {
					const msg = "Please enter a positive number.";
					Noti.create({type: "e", msg});
					return;
				}
			}
		}

		updateAcctInfo(filteredChanges);
	}

	useEffect(() => {
		const timer = setTimeout(() => {
			getList();
		}, 500);

		return () => clearTimeout(timer);
	}, []);

	useEffect(() => {
		setSiteData(props.siteInfo);
		if (loggedCountry === "TH" || siteAdmin) {
			if (props.siteInfo?.client_id != null || props.siteInfo?.exu_cl != null) {
				const mail_client_id = props.siteInfo?.client_id != null ? props.siteInfo?.client_id : props.siteInfo?.exu_cl;
				const uriPostal = `/select/postal/${mail_client_id}`;
				const postalsList = async () => await GYAxios.get(uriPostal);
				postalsList().then((res) => {
					if (res.data.length !== 0) {
						const temps = res.data.map((v) => {
							return {label: v.label, value: v.value};
						});
						temps.unshift({label: "Add new", value: 0});
						setPostalsList(temps);
					} else if (res.data.length === 0) {
						setPostalsList([{label: "Add new", value: 0}]);
					}
				});
			}
			else {
				setPostalsList([{label: "Add new", value: 0}]);
			}
		}
	}, [props.siteInfo]);

	useEffect(() => {
		if (siteData && listRetrieved) {
			// == instead of !== because we want to compare null with undefined
			let defaultValues = {};
			if (siteAcct) setIsReadOnly(false);
			Object.entries(siteData).forEach(([key, val]) => {
				defaultValues[key] = siteData[key];
			});

			if (defaultValues?.["isSent"] === 1 && defaultValues?.["isRejected"] === 0) setIsReadOnly(true);
			reset({...defaultValues});
		}
	}, [siteData, listRetrieved]);

	useEffect(() => {
		if (postal_id != 0) {
			unregister("mail_name");
			unregister("mail_phone_no");
			unregister("mail_bill_add");
		}
	}, [postal_id]);

	return (<>
		{siteView && <Container fluid id={styles.formSite}>
			{siteAdmin && (
				<Row style={{margin: "10px 0"}}>
					<Col sm={3} style={{padding: 0}}>
						<button
							className="btn btn-success"
							onClick={(e) => setIsReadOnly(!isReadOnly)}
						>
							Edit
						</button>
					</Col>
				</Row>
			)}

			<form onSubmit={handleSubmit(onSubmit)}>
				<fieldset disabled={isReadOnly}>
					<Row className={styles.eachLine}>
						<Col sm={6}>
							CLIENT NAME - SITE NAME
							<input
								defaultValue={`${siteData.temp_client_name} - ${siteData.site_name}`}
								type="text"
								className={`${styles.inputField} ${styles.disabled}`}
								value={`${siteData.temp_client_name} - ${siteData.site_name}`}
							/>
						</Col>

						<Col sm={3}>
							TAX ID {renderInput("tax_id", 31, false)}
						</Col>
						<Col sm={3}>
							LOCATION {renderInput("location", 100, false)}
						</Col>
					</Row>

					<Row className={styles.eachLine}>
						<Col sm={6}>
							BILLING NAME {renderInput("billing_name", 255, false)}
						</Col>

						<Col sm={6}>
							BILLING ADDRESS {renderInput("billing_address", 255, false)}
						</Col>
					</Row>

					<Row className={styles.eachLine}>
						<Col sm={6}>
							ELECTRICITY AUTHORITY
							<Controller
								control={control}
								name="EA_id"
								defaultValue={EA_id}
								render={({onChange, value}) =>
									renderSelect("se", onChange, easList, value)
								}
							/>
						</Col>

						<Col sm={6}>
							TARIFF TYPE
							<Controller
								control={control}
								name="tariff_id"
								defaultValue={tariff_id}
								render={({onChange, value}) =>
									renderSelect("se", onChange, tariffsList, value)
								}
							/>
						</Col>
					</Row>

					<Row className={styles.eachLine}>
						<Col sm={3}>
							Take or Pay?
							<Controller
								control={control}
								name="ToP"
								defaultValue={ToP}
								render={({onChange, value}) =>
									renderSelect("se", onChange, ToP_choices, value)
								}
							/>
						</Col>
						<Col sm={3}>
							Currency
							<Controller
								control={control}
								name="currency"
								defaultValue={currency}
								render={({onChange, value}) =>
									renderSelect("se", onChange, currencies, value)
								}
							/>
						</Col>
					</Row>

					<Row className={styles.eachLine}>
						<Col sm={3}>
							SOLAR ENTITY
							<Controller
								control={control}
								name="solar_entity"
								defaultValue={solar_entity}
								render={({onChange, value}) =>
									renderSelect("se", onChange, entitiesList, value)
								}
							/>
						</Col>

						<Col sm={3}>
							CREDIT TERM (DAYS)
							{renderInput("credit_term", 2, false, "number")}
						</Col>

						<Col sm={6}>
							BANK ACCOUNT
							<Controller
								control={control}
								name="bank_id"
								defaultValue={bank_id}
								render={({onChange, value}) =>
									renderSelect("se", onChange, banksList, value)
								}
							/>
						</Col>
					</Row>

					<Row className={styles.eachLine}>
						<Col sm={3}>
							CUSTOMER ID (we are removing it soon)
							<Controller
								control={control}
								name="customer_id"
								defaultValue={{}}
								render={() =>
									<Select
										isDisabled={true}
										options={[]}
									/>
								}
							/>
						</Col>

						<Col sm={3}>
							SITE CODE {renderInput("site_code", 15, false)}
						</Col>
					</Row>

					<Row className={styles.eachLine}>
						<Col sm={3}>
							DISCOUNT ON PEAK (%) {renderInput("discount_on", 2, false, "number")}
						</Col>

						<Col sm={3}>
							DISCOUNT OFF PEAK (%) {renderInput("discount_off", 2, false, "number")}
						</Col>
						<Col sm={3}>
							{(siteData?.country == "VN" || loggedCountry === "VN") ? "EVN SHARING (%)" : "FT DISCOUNT (%)"}
							{renderInput("FT_discount", 2, false, "number")}
						</Col>
					</Row>

					{(loggedCountry === "TH" || siteAdmin) && (<Row className={styles.eachLine}>
						<Col sm={12}>
							POSTAL BILLING INFORMATION
							<Controller
								control={control}
								name="postal_id"
								defaultValue={postal_id}
								render={({onChange, value}) =>
									renderSelect("se", onChange, postalsList, value)
								}
							/>
						</Col>
					</Row>)}

					{postal_id == 0 && <Row className={styles.eachLine}>
						<Col sm={3}>
							POSTAL ATTENTION
							{renderInput("mail_name", 51, true)}
							{errors.mail_name && errors.mail_name.type === "required" && (
								<span className={styles.errorDis}>This is required</span>
							)}
						</Col>
						<Col sm={3}>
							POSTAL PHONE NO.
							{renderInput("mail_phone_no", 21, true)}
							{errors.mail_phone_no && errors.mail_phone_no.type === "required" && (
								<span className={styles.errorDis}>This is required</span>
							)}
						</Col>

						<Col sm={6}>
							<span
								onMouseEnter={() => setShowInfo(true)}
								onMouseLeave={() => setShowInfo(false)}
							>POSTAL ADDRESS</span>
							{showInfo && (
								<div className={styles.infoCard}
								>
									<h5>Format for address</h5>
									<p>Please add <b style={{fontSize: "15px"}}>\n</b> when you need to make it to another line.</p>
									<p>E.g: <br />
										48/43-44 TISCO Tower 19th Floor,<b style={{fontSize: "15px"}}>\n</b>
										North Sathorn Road, Silom, Bangrak, <b style={{fontSize: "15px"}}>\n</b>
										Bangkok 10500<b style={{fontSize: "15px"}}>\n</b>
										Thailand
									</p>


								</div>
							)}
							{renderInput("mail_bill_add", 221, true)}
							{errors.mail_bill_add && errors.mail_bill_add.type === "required" && (
								<span className={styles.errorDis}>This is required</span>
							)}
						</Col>
					</Row>}

					<Row className={styles.eachLine}>
						<div className={styles.othersDiv}>
							OTHER COMMENTS
							<Col sm={12}>
								<textarea
									className={styles.textField}
									value={comment !== null ? comment : ""}
									{...register("comment", {maxLength: 500})}
									onChange={(e) => setValue("comment", e.target.value)}
									maxLength={500}
								/>
							</Col>
						</div>
					</Row>
				</fieldset>

				{acctApproval && <Row className={styles.eachLine}>
					<Col sm={6}>
						<input
							type="button"
							value="Approve"
							className={`btn btn-primary ${styles.mainBtns}`}
							onClick={() => approveSite()}
						/>
					</Col>
					<Col sm={6}>
						<input
							type="button"
							value="Reject"
							className={`btn btn-info ${styles.mainBtns}`}
							onClick={() => rejectSite()}
						/>
					</Col>
				</Row>}

				<Row className={styles.eachLine}>
					<Col sm={6}>
						{!isReadOnly && (
							<input
								type="submit"
								value="Save"
								className={`btn btn-primary ${styles.mainBtns}`}
							/>
						)}
					</Col>
					<Col sm={6}>
						<input
							type="button"
							value={acctApproval ? "Back" : "Cancel"}
							className={acctApproval ? `btn btn-dark ${styles.mainBtns}` : `btn btn-primary ${styles.mainBtns}`}
							onClick={() => history.push('/solar/administration/site-creation/manage-site/invoicing-info-table')}
						/>
					</Col>
				</Row>
			</form>

		</Container>}

		{needLoader && <div className="overlay translucent" style={showLoader}>
			<Loader
				translucent={true}
				customStyle={{
					width: "150px",
					height: "150px",
					position: "fixed",
					left: "50%",
					top: "35%",
				}}
			/>
		</div>}
	</>);
};
